var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.initializing
    ? _c(
        "div",
        {
          staticClass: "cog-field__placeholder cog-input cog-lookup--loading",
          class: { "is-read-only": _vm.readonly },
          attrs: { tabindex: 0 },
          on: { focus: _vm.handleFocus, blur: _vm.handleBlur }
        },
        [
          _c(
            "div",
            { staticClass: "cog-field__placeholder-inner" },
            [_vm._v("\n\t\t \n\t\t"), _c("i-cog")],
            1
          )
        ]
      )
    : _c("div", { staticClass: "cog-choice cog-lookup" }, [
        _c(
          "div",
          { staticClass: "cog-lookup__slot-container cog-choice-option" },
          [
            _vm._t("default", null, {
              value: _vm.slot,
              choiceOptions: _vm.choiceOptions
            })
          ],
          2
        )
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }